import React, { useEffect, useState } from 'react';

import SectionNews from './Sections/blog';
import SectionInfo from './Sections/informacoes';
import SectionAbout from './Sections/sobre';
import SectionCTA from './Sections/cta';
import SectionEvents from './Sections/eventos';
import SectionBanners from './Sections/banners';

import MainLayout from '../../Layout/main';
import { fetchData } from '../../../Api';
import { PostInterface, BannerInterface, EventInterface } from '../../Services/types';
import { Helmet } from 'react-helmet-async';

const Home: React.FC<any> = ({initialData} : any) => {    
    function proccessBanners()
    {
        const formattedBanners = initialData?.banners.map((banner: BannerInterface) => ({
            ...banner,
            dataInicial: new Date(banner.dataInicial),
            dataFinal: new Date(banner.dataFinal),
        })) ?? [];
        
        return formattedBanners
    }

    function proccessEvents()
    {
        const formattedEvents = initialData?.events.map((event: EventInterface) => ({
            ...event,
            data: new Date(event.data),
        })) ?? [];

        return formattedEvents;
    }

    function proccessPosts()
    {
        const formattedPosts = initialData?.posts.map((post: PostInterface) => ({
            ...post,
            data: new Date(post.data),
        })) ?? [];

        return formattedPosts;
    }

    const [banners, setBanners] = useState<BannerInterface[]>(proccessBanners());
    const [events, setEvents] = useState<EventInterface[]>(proccessEvents());
    const [posts, setPosts] = useState<PostInterface[]>(proccessPosts());
    
    useEffect(() => {    
        if (initialData) return;

        const loadData = async () => {
            const response = await fetchData(`home`);
            if(response){
                if (response.banners) {
                    const formattedBanners = response.banners.map((banner: BannerInterface) => ({
                        ...banner,
                        dataInicial: new Date(banner.dataInicial),
                        dataFinal: new Date(banner.dataFinal),
                    }));
                    setBanners(formattedBanners);
                }
                if (response.events) {
                    const formattedEvents = response.events.map((event: EventInterface) => ({
                        ...event,
                        data: new Date(event.data),
                    }));
                    setEvents(formattedEvents);
                }
                if (response.posts) {
                    const formattedPosts = response.posts.map((post: PostInterface) => ({
                        ...post,
                        data: new Date(post.data),
                    }));
                    setPosts(formattedPosts);
                }
            }
        };  
        loadData();
    }, []);

    return (
        <>
            <Helmet>
                {/* {banners && banners.length > 0 ? 
                    <title>{banners[0].titulo} | Uniexpo</title>
                :
                    <title>Uniexpo</title>
                } */}
                <title>Feira de Profissões - Uniexpo</title>
            </Helmet>

            <MainLayout>
                {banners &&
                    <SectionBanners banners={banners} />
                }

                <div className={`${events && events.length == 0 ? 'mb-44' : ''}`}>
                    <SectionEvents events={events} />
                </div>
                
                <SectionCTA />
                <SectionAbout />
                <SectionInfo />
                {posts && posts.length > 0 &&
                    <SectionNews posts={posts}/>
                }
            </ MainLayout>
        </>
    );
};

export default Home;
